import React, { useRef } from "react";
import { notification } from "antd";
import {
  Wrapper,
  Category,
  Add,
  Name,
  Required,
  StapletIcon,
  RemoveIcon,
} from "./FileInput.styled";

interface Props {
  category?: string;
  required?: boolean;
  value?: FileList[0];
  onChange?: (val) => void;
}

export default function FileInput({
  category,
  required = false,
  value,
  onChange,
  ...restProps
}: Props) {
  const ref = useRef<HTMLInputElement>();

  return (
    <Wrapper>
      {!!category && (
        <Category>
          {required && <Required>*</Required>}

          {category}
        </Category>
      )}
      <input
        ref={ref}
        type="file"
        accept=".jpg, .jpeg, .png, .tiff, .pdf, .docx, .xlsx"
        style={{ display: "none" }}
        onChange={(e) => {
          const file = e.target.files[0];
          const regex = /[*|":<>[\]{}`\\'&%~#]/.test(file.name);
          const doubleDot = !file.name.match(/\.\./);
          const dot = !file.name.match(/^[.]/);

          if (file.size === 0) {
            notification.error({
              placement: "bottomRight",
              message: "Файл не может быть пустым",
            });
          } else if (file.size > 10 * 1024 * 1024) {
            notification.error({
              placement: "bottomRight",
              message: `Размер файла ${file.name} больше 10мб`,
            });
          } else if (regex || doubleDot === false || dot === false) {
            notification.error({
              placement: "bottomRight",
              message: `Имя загружаемого файла ${file.name} содержит недопустимые знаки. Измените имя файла.
              К недопустимым относятся следующие знаки: ~ " # % & * : < > ? / \\ { | }. Имя не может начинаться или завершаться точкой,
              а также не может содержать несколько точек подряд.`,
              duration: null,
            });
          } else {
            onChange(file);
          }
        }}
        {...restProps}
      />

      <StapletIcon onClick={() => ref.current.click()} />

      {value ? (
        <>
          <Name>{value?.name}</Name>

          <RemoveIcon onClick={() => onChange(null)} />
        </>
      ) : (
        <Add onClick={() => ref.current.click()}>
          <span>Добавить</span>
        </Add>
      )}
    </Wrapper>
  );
}
